import { useMutation, useQueryClient } from '@tanstack/react-query';

import { clearAmplitudeUserSession } from '~analytics/amplitude';

import IntercomService from '../../../../intercom/IntercomService';
import { logout } from '../../../api/auth';

export function useLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: logout,
    onMutate: () => {
      IntercomService.shutdown();
      clearAmplitudeUserSession();
      queryClient.removeQueries();
      window.pubnub.unsubscribeAll();
    },
  });
}
